<template>
	<!-- 主页面 -->
	<div>
		<van-tabbar v-show="tabbarShow" v-model="active" @change="onChange">
			<van-tabbar-item icon="wap-home-o">首页
				<!-- <span>首页</span>
				<img slot="icon" slot-scope="props" :src="props.active ? home.active : home.normal" /> -->
			</van-tabbar-item>
			<van-tabbar-item icon="todo-list-o">签约列表
				<!-- <span>合同管理</span>
				<img slot="icon" slot-scope="props"
					:src="props.active ? contractmanage.active : contractmanage.normal" /> -->
			</van-tabbar-item>
			<van-tabbar-item>
				<span>企业管理</span>
				<img slot="icon" slot-scope="props"
					:src="props.active ? entermanage.active : entermanage.normal" /></van-tabbar-item>
			<van-tabbar-item icon="user-o">我的</van-tabbar-item>
		</van-tabbar>
		<myheader :backFlag="false" :headTitle="this.headTitle"></myheader>
		<transition :name="names">
			<keep-alive :include="indexKeepAlive">
				<router-view class="router-view"></router-view>
			</keep-alive>
		</transition>
	</div>
</template>

<script>
	import {
		mapGetters
	} from "vuex";
	import Vue from "vue";
	import {
		testVersion
	} from "../utils/nativeTestDemo"
	import {
		Tabbar,
		TabbarItem
	} from "vant";
	//Vue.use(Tabbar).use(TabbarItem);
	export default {
		name: "Index",
		components: {
			[Tabbar.name]: Tabbar,
			[TabbarItem.name]: TabbarItem,
		},
		data() {
			return {
				active: window.sessionStorage.getItem('event') || 0,
				home: {
					normal: require("../assets/images/icon-shouye-s.png"),
					active: require("../assets/images/icon-shouye.png"),
				},
				contractmanage: {
					normal: require("../assets/images/icon-work-s.png"),
					active: require("../assets/images/icon-work.png"),
				},
				entermanage: {
					normal: require("../assets/images/enterprise_manage.svg"),
					active: require("../assets/images/enterprise_managed.svg"),
				},
				headTitle: this.headTitle,
				//屏幕高度
				height: 0,
				//底部是否显示
				tabbarShow: true,
			};
		},
		activated() {
			console.log('index-activated')
			if (window.sessionStorage.getItem('event')) {
				var num = window.sessionStorage.getItem('event')
				this.active = +num
			}
			if(this.$store.state.indexActive){
				this.active = this.$store.state.indexActive
				this.$store.commit("changeIndexActive", 0)
			}
			if (this.$store.state.reLogin) {
				this.active = 0
				this.$store.commit("changeReLogin", '')
			}
			if (!this.$store.state.newquicksignfiles && !this.$store.state.harmonysharefiles) {
				this.onChange(this.active)
			}
			//this.$Toast('刷新进入index--'+this.active)
		},
		deactivated() {
			//console.log('index-deactivated')
		},
		created() {
			//console.log('index-created')
		},
		updated() {
			//console.log('index-updated')
		},
		destroyed() {
			//console.log('index-destroyed')
		},
		//拦截设置keepalive是否缓存
		beforeRouteLeave(to, from, next) {
			console.log("index-beforeRouteLeave", to, from);
			// if (to.meta.index > from.meta.index) {
			// 	if (from.meta.keepAlive) {
			// 		this.$store.commit('addKeepAlive', 'Index');
			// 	}
			// 	console.log(from.name);
			// } else {
			// 	if (from.meta.keepAlive) {
			// 		this.$store.commit('removeKeepAlive', 'Index');
			// 	}
			// }
			next();
		},
		mounted() {
			//console.log('index-mounted')
			this.init()
			window.addEventListener('resize', this.resize);
			//window.addEventListener('resize', this.twoResize);
		},
		computed: {
			...mapGetters(["direction", "indexKeepAlive"]),
			// 路由跳转动画
			names() {
				return "vux-pop-" + (this.direction === "forward" ? "in" : "out");
			},
			//初始化赋值
			resize() {
				if (this.height === 0) {
					this.height = document.body.clientHeight
				}
			},
		},
		watch: {
			$route(to, from) {
				console.log('index-watch-route', from, to)
				// if (to.path == '/home' && to.query.status) {
				// 	this.headTitle = '石化e签'
				// 	this.active = 0
				// }
				if (to.path === '/home' && (this.$store.state.newquicksignfiles || this.$store.state.harmonysharefiles)) {
					console.log('jump newquicksign 1')
					this.$store.dispatch(this.$LoadShow, true)
					setTimeout(() => {
						this.$store.dispatch(this.$LoadShow, false)
						this.$router.push({
							path: '/newquicksign',
							query: {
								type: 0
							}
						})
					}, 1000)
				}
				if (to.path === '/home' && this.$store.state.quickSignContractDetails) {
					console.log('jump contractdetails 1')
					const info = this.$store.state.quickSignContractDetails
					const infos = JSON.parse(info)
					this.$store.dispatch(this.$LoadShow, true)
					setTimeout(() => {
						this.$store.dispatch(this.$LoadShow, false)
						this.$router.push({
							path: '/contractdetails',
							query: {
								contractId: infos[0][0],
								contractStatus: infos[0][1],
							}
						})
					}, 1000)
				}
				if (to.path === '/contractmanagement' && to.query.status) {
					this.headTitle = ''
					this.active = 1
				}
				if (to.path == '/enterpriselist' && to.query.status) {
					this.headTitle = '企业管理'
					this.active = 2
				}
				// if (to.path == '/user' && to.query.status) {
				// 	this.headTitle = '我的'
				// 	this.active = 3
				// }
				window.sessionStorage.setItem('event', this.active)
			},
		},
		methods: {
			init() {
				if (window.plus && plus.os.name === 'iOS') {
					var imgpath = plus.io.convertLocalFileSystemURL('./scancode/images/left_back.png')
					imgpath = window.location.origin + imgpath
					console.log('文件存在', imgpath)
					plus.io.resolveLocalFileSystemURL(imgpath, function(entry) {
						console.log('文件存在', entry.toLocalURL())
					}, function(error) {
						console.log('文件不存在', error)
					})
				}
			},
			//屏幕变化时调用
			twoResize() {
				if (this.height > 0 && document.body.clientHeight < this.height) {
					this.tabbarShow = false
				} else {
					this.tabbarShow = true
				}
			},
			// 切换时的回调。
			onChange(event) {
				console.log('onChange', event)
				switch (event) {
					case 0:
						this.headTitle = '石化e签'
						this.switchItem('/home')
						break;
					case 1:
						this.headTitle = ''
						this.switchItem('/contractmanagement')
						break;
					case 2:
						this.headTitle = '企业管理'
						this.switchItem('/enterpriselist')
						break;
					case 3:
						this.headTitle = '我的'
						this.switchItem('/user')
						break;
				}
				//this.active = event
				window.sessionStorage.setItem('event', event)
			},
			//切换item页面
			switchItem(path) {
				// console.log('switchItem', path)
				//TODO切换时验证用户是否实人认证
				if (path === '/contractmanagement' || path === '/enterpriselist') {
					if (this.$store.state.userInfo.certifyState != 2) {
						this.$Toast('请先进行个人认证!')
						return
					}
				}
				if (this.$router.currentRoute.path != path) {
					this.$router.replace(path)
				}
			},
		},
	};
</script>

<style scoped lang="scss">
	@import "../styles/global.css";
</style>